import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  installationId: string;
  zoom?: number;
}

export function useUpdateInstallationPlanning() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      post({
        url: `/projects/${params.projectId}/installations/${params.installationId}/planning`,
        body: params,
      }),
    onSuccess: (_, { projectId, installationId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallations(projectId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallation(projectId, installationId),
      });
    },
  });

  const updateInstallationPlanning = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    updateInstallationPlanning,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
